export default "__VITE_ASSET__c301bfcc__"